<section class="content tab-section d-flex">

  <div class="content-block flex-grow-1">
    <div class="tab-box mb-2 align-items-center">
      <div class="me-3 cursor-pointer" (click)="onBack()"><img src="assets/images/icons/back_icon.svg" alt=""></div>
      <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2" id="i-4"
        (click)="onTabChange('open_shift')" [ngClass]="currentTab == 'open_shift' ? 'active-tab' : ''"
        matTooltip="Requests for the Open shifts">
        <div class="tab-txt ps-1 ps-sm-2">Open shifts</div>
      </div>
      <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2" id="i-1"
        matTooltip="Request for the Swap shifts" [ngClass]="currentTab == 'swap_shift' ? 'active-tab' : ''"
        (click)="onTabChange('swap_shift')">
        <div class="tab-txt ps-1 ps-sm-2">Shift replacements</div>
      </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap">
      <div class="search-cont">
        <!-- <div class=" s-in form-input">
         <input type="text" class="form-control" placeholder="What do you want to Learn ?">
         <mat-icon class="input-icon">search</mat-icon>
       </div> -->
        <div class="s-in form-input" style="position:relative">
          <mat-icon class="input-icon">search</mat-icon>
          <input type="text" placeholder="{{'COMMON.SEARCH' | translate}}" class="form-control"
            [(ngModel)]="searchInput" (input)="onSearch($event)" (keyup.enter)="onGo()" />
          <!-- <button type="submit" (click)="noticesList()">Go</button> -->
        </div>
        <div class="go-b" (click)="onGo()">{{"COMMON.GO" | translate}}</div>
        <div class="s-item d-box " (click)="onFilterView()">
          <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
        </div>
      </div>
    </div>
    <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
    <div class="tab-content flex-grow-1 d-flex flex-column mt-3">
      <div *ngIf="currentTab=='open_shift'">
        <div class="flex-grow-1 white-bg d-flex align-items-center justify-content-center " style="position: relative"
          *ngIf="isSpinnerLoading">
          <div class="custom-loader"></div>
        </div>
        <div class="table-container flex-grow-1 " *ngIf="!isSpinnerLoading">
          <table class="" mat-table [dataSource]="dataSource" class="mat-elevation-z8"
            *ngIf="dataSource.data.length!=0">
            <!-- <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef >
              {{"COMMON.TITLE"|translate}}</th>
            <td mat-cell *matCellDef="let element"> {{element.tit }} </td>
          </ng-container> -->
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>
                {{"COMMON.DATE"|translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.st_dt | dates }} </td>
            </ng-container>
            <ng-container matColumnDef="company">
              <th mat-header-cell *matHeaderCellDef>
                {{"COMMON.COMPANY"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex">
                  <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture" iType="company_logo"></div>
                  <div class="">
                    <div class="main-head">{{element.company_name}}</div>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="employee">
              <th mat-header-cell *matHeaderCellDef>
                {{"COMMON.CANDIDATE"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex">
                  <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"></div>
                  <div class="">
                    <div class="main-head">{{element.first_name}} {{element.last_name}}</div>
                    <div class="sub-head">{{element.email}}</div>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef>
                {{"COMMON.CATEGORY"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="text-bold">{{element.j_c}}</div>
                <div>{{element.j_sc}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef>
                {{"RECRUITER.ADDSHIFT.STARTTIME"|translate}} - {{"RECRUITER.ADDSHIFT.ENDTIME"|translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.st_ti }} - {{element.ed_ti }}</td>
            </ng-container>
            <ng-container matColumnDef="location">
              <th mat-header-cell *matHeaderCellDef>
                Location </th>
              <td mat-cell *matCellDef="let element">
                <div class="hide-lines-2">{{element.add}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>
                {{"COMMON.STATUS"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="text-bold st-box  d-flex ">
                  <span class="active badge-c d-box" *ngIf="element.app==1">{{"Accepted"|translate}} 1</span>
                  <span class="pending badge-c d-box" *ngIf="element.app==2">{{"Pending"|translate}} 2</span>
                  <span class="un-attend   badge-c d-box" *ngIf="element.app==0">{{"Rejected"|translate}} 3</span>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>{{"COMMON.ACTION"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex">
                  <div class="status-box accept me-2" matTooltip="{{'BUTTON.ACCEPT' | translate}}"
                    [ngClass]="{'opacity': element.app==1}" (click)="onConfirmationModal(element,1)">
                    <img src="assets/images/icons/tick_correct.svg" class="img-fluid" alt="">
                  </div>
                  
                  <div class="status-box reject " matTooltip="{{'BUTTON.REJECT' | translate}}"
                    [ngClass]="{'opacity': element.app==0}" (click)="onConfirmationModal(element,0)">
                    <img src="assets/images/icons/cancel.svg" class="img-fluid" alt="">
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div class="mat-table__message" *ngIf="dataSource.data.length==0">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
        </div>
        <div class="pagination-cont" *ngIf="dataSource.data.length!=0">
          <div class="show-item">
            {{"COMMON.SIP" | translate}}
            <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
              [(ngModel)]="config.itemsPerPage">
              <option [value]="item" *ngFor="let item of pageSizeOptions">
                {{ item }}
              </option>
            </select>
          </div>
          <div class="page-c">
            <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
              [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
          </div>
        </div>
      </div>
      <div *ngIf="currentTab=='swap_shift'"></div>
    </div>
  </div>
</section>